// extracted by mini-css-extract-plugin
module.exports = {"background":"Loader_background__GXjQe","loader":"Loader_loader__bfPh2","loaderRing":"Loader_loaderRing__SL96I"};